function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("path", {
  d: "M16.61 0H3.13A3.14 3.14 0 000 3.14v9a3.14 3.14 0 003.13 3.14h13.48a3.15 3.15 0 003.14-3.14v-9A3.15 3.15 0 0016.61 0zM18 12.11a1.41 1.41 0 01-1.41 1.41H3.13a1.41 1.41 0 01-1.4-1.41V5.4l6.82 3.17a3.22 3.22 0 002.65 0L18 5.4zm0-8.62L10.47 7a1.43 1.43 0 01-1.19 0L1.73 3.49v-.35a1.41 1.41 0 011.4-1.41h13.48A1.41 1.41 0 0118 3.14z",
  fill: "#393c51",
  "data-name": "Capa 6"
}));

var SvgEmail = function SvgEmail(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 19.75 15.25"
  }, props), _ref);
};

export default SvgEmail;